import { render, staticRenderFns } from "./specialtyDetail.vue?vue&type=template&id=b2934848&scoped=true"
import script from "./specialtyDetail.vue?vue&type=script&lang=js"
export * from "./specialtyDetail.vue?vue&type=script&lang=js"
import style0 from "./specialtyDetail.vue?vue&type=style&index=0&id=b2934848&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2934848",
  null
  
)

export default component.exports